import { ShopPayPaymentRequest } from '../../hooks/useShopPaySession/types';
import getToken from '../cognito';

export const createPaymentRequestSession = async ({
  token,
  shopPayPaymentMethodToken,
  shopPayPaymentRequest,
}: {
  token: string;
  shopPayPaymentMethodToken: string;
  shopPayPaymentRequest: ShopPayPaymentRequest;
}) => {
  try {
    let accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      accessToken = (await getToken()) ?? '';
      localStorage.setItem('access_token', accessToken);
    }
    const response = await fetch(
      `${process.env.BASE_API_URL}/payment-hub/payment-request-session`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          token,
          shopPayPaymentMethodToken,
          shopPayPaymentRequest,
        }),
      },
    );
    if (response.ok) {
      return (await response.json()) as { method: string };
    }
    throw new Error('Failed to create payment request session');
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    } else {
      throw new Error('An unknown error occurred');
    }
  }
};
